import { SCREENS } from "utils/constants";
import Create from "./Create";
import Detail from "./Detail";
import List from "./List";

const routes = [
  {
    path: SCREENS.PRIVATE.ADMIN.FEEDS.LIST,
    exact: true,
    element: <List />,
  },
  {
    path: SCREENS.PRIVATE.ADMIN.FEEDS.CREATE,
    exact: true,
    element: <Create />,
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.FEEDS.DETAIL}/:id`,
    exact: true,
    element: <Detail />,
  },
];

export default routes;
